import { useEffect, useState, useCallback } from 'react';
import { persistence } from 'services/persistence';
import { usePolling } from 'hooks/usePolling';

/**
 * Polls a localStorage key and derives an integer count via `countFn`.
 * Listens for cross-tab `storage` events and re-checks on a 2-second
 * interval so same-tab writes are also picked up.
 */
export function useLocalStorageCount<T>(
  key: string,
  defaultValue: T,
  countFn: (value: T) => number,
): number {
  const [count, setCount] = useState(0);

  const update = useCallback(() => {
    const data = persistence.getJSON<T>(key, defaultValue);
    setCount(countFn(data));
  }, [key, defaultValue, countFn]);

  usePolling(update, 2000);
  useEffect(() => {
    window.addEventListener('storage', update);
    return () => window.removeEventListener('storage', update);
  }, [update]);

  return count;
}
